/**
 * localStorage utilities for application data.
 * Centralizes all storage keys and clear logic.
 */

export const STORAGE_KEYS = {
  token: 'token',
  passwordSet: 'passwordSet',
  guestUser: 'guestUser',
  guestFirstName: 'guestFirstName',
  guestLastName: 'guestLastName',
  guestCart: 'guestCart',
  guestWishlist: 'guestWishlist',
  guestCheckoutData: 'guestCheckoutData',
  guestOrderCount: 'guestOrderCount',
  resendTime: 'resendTime',
};

const AUTH_KEYS = [STORAGE_KEYS.token, STORAGE_KEYS.passwordSet];
const GUEST_KEYS = [
  STORAGE_KEYS.guestUser,
  STORAGE_KEYS.guestFirstName,
  STORAGE_KEYS.guestLastName,
  STORAGE_KEYS.guestCart,
  STORAGE_KEYS.guestWishlist,
  STORAGE_KEYS.guestCheckoutData,
  STORAGE_KEYS.guestOrderCount,
];

/**
 * Clears all auth-related localStorage (logout).
 * Removes: token, passwordSet, guest data, resendTime, and any resendTime_* keys.
 */
export function clearAuthStorage() {
  [...AUTH_KEYS, ...GUEST_KEYS, STORAGE_KEYS.resendTime].forEach((key) => {
    localStorage.removeItem(key);
  });
  Object.keys(localStorage)
    .filter((key) => key.startsWith('resendTime_'))
    .forEach((key) => localStorage.removeItem(key));
}

/**
 * Clears only guest-related localStorage.
 * Call when user successfully logs in as normal user (password/OTP).
 */
export function clearGuestData() {
  GUEST_KEYS.forEach((key) => {
    localStorage.removeItem(key);
  });
}
